import {useEffect, useState} from 'react';
import {
    GetIdentityValidationType,
    GetValidationId
} from '../../../../../reduxToolkit/Visitor/VisitorApi';
import {useNavigate, useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import { FILE_TYPE_MODEL, IDENTITY_VALIDATION_TYPE_MODEL } from '../../Visitor/Model/Model';
import routes from '../../../../../Routes/routes';
import {setSelectedDocumentType} from '../../../../../reduxToolkit/Visitor/VisitorSlice';
import {useDispatch, useSelector} from 'react-redux';
import {GetInvitationById} from '../../../../../reduxToolkit/Invitation/InvitationApi';
import {getUrlParameters} from "../Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ChooseValidationTypeApp = () => {
    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { getInvitationById } = useSelector((state) => state.InvitationSlice);
    const { getIdentityValidationType } = useSelector((state) => state.VisitorSlice);

    const [selectionType, setSelectionType] = useState('');

    useEffect(() => {
        dispatch(GetValidationId());
    }, []);

    useEffect(() => {
        if (!getInvitationById || getInvitationById?.length <= 0) {
            dispatch(GetInvitationById(id));
            dispatch(GetIdentityValidationType());
        }
    }, [id]);

    const getUrl = () => {
        if (selectionType == '') {
            toast.warn(t("you_must_select_an_option"));
            return null;
        }
        const documentType = selectionType == FILE_TYPE_MODEL.INE.id ? FILE_TYPE_MODEL.INE.identifier : FILE_TYPE_MODEL.PASSPORT.identifier
        const isAutomatic = IDENTITY_VALIDATION_TYPE_MODEL.VERIDAS.id ==  getIdentityValidationType;
        if(isAutomatic){
            dispatch(setSelectedDocumentType(documentType));
            navigate(getUrlParameters({ url: routes.veridasIntegration.documentPage, id, guardFlowId }));
        } else navigate(getUrlParameters({ url: routes.invitationDetails.createExternal + selectionType +"/", id, guardFlowId }))
    }

    return {
        t,
        navigate,
        id,
        guardFlowId,
        selectionType,setSelectionType,
        getUrl,
        getInvitationById,
        getIdentityValidationType
    }
}

export default ChooseValidationTypeApp
